@if (accountInitialCopyResources !== PREVIOUSLY_USED_ACCOUNT) {
    <div>
        <div style="text-align: center; margin-top: 5px">
            <br />
            <br />
            <span style="font-size: 1.3em">{{ 'general.pleaseWaitInitAccount' | transloco }}</span>
            <br />
            <span style="font-size: 1.3em">{{ 'general.likeTherty' | transloco }}</span>
            <br />
            <br />
            <mat-icon style="position: relative; left: -5px; top: 6px">watch_later</mat-icon>
            <span style="font-size: 1.3em">{{ 'general.totalResourcesDownloaded' | transloco }}
                : {{ accountInitialCopyResources }}</span>
            <br />
            <br />
        </div>
    </div>
} @else {
    <div class="mainSliderBg" [ngClass]="{'vertical': vertical}">
        <div class="d-flex-center panel-title">
            <mat-icon>slow_motion_video</mat-icon>
            <span>{{ 'general.recent' | transloco }} {{ 'general.scenes' | transloco }}&nbsp;&nbsp;</span>
            <button mat-icon-button (click)="toggleScenePreview2()" matTooltip="toggle scene preview"
                    class="mini-button">
                @if (scenePreviewEnabled) {
                    <mat-icon>layers</mat-icon>
                }
                @if (!scenePreviewEnabled) {
                    <mat-icon>layers_clear</mat-icon>
                }
            </button>
        </div>
        @if (recentScenes.length === 0) {
            <div style="overflow-x: hidden; margin-top: 10px;">
                <ngx-skeleton-loader
                    count="1"
                    animation="progress-dark"
                    appearance="circle"
                    [theme]="{
                                'border-radius': '5px',
                                'height': '140px',
                                'width': '100%',
                                'background-color': 'var(--background-color17)'
                        }">
                </ngx-skeleton-loader>
                <!-- <app-loading [type]="-1" [size]="'50px'"></app-loading> -->
            </div>
        } @else {
            <div class="flicking-wrapper">
                <ngx-flicking class="flicking" [plugins]="vertical ? [] : plugins" [options]="options">
                    @for (item of recentScenes; track item; let i = $index) {
                        <div flicking-panel class="panel fade-in-item"
                             [style.animation-delay]="(i * 40) + 'ms'">
                            <div class="preview">
                                @if (scenePreviewEnabled) {
                                    <app-scene-preview
                                        [setSelectedSceneId]="item.previewSceneId"
                                        [setSceneWidth]="item.width"
                                        [setSceneHeight]="item.height"
                                        [previewWidth]="240"
                                        [autoScale]="true"
                                        (sceneLoaded)="onSceneLoaded($event)">
                                    </app-scene-preview>
                                }
                                @if (!scenePreviewEnabled) {
                                    <img src="./assets/images/empty_scene.png" style="height: 100%;" />
                                }
                                @if (!item.loaded) {
                                    <ngx-skeleton-loader
                                        animation="progress-dark"
                                        class="preview-loader"
                                        [theme]="{
                                                'height': '100%',
                                                'border-radius': '0',
                                                'background-color': 'var(--background-color16)'
                                            }">
                                    </ngx-skeleton-loader>
                                }
                            </div>
                            <div class="title">{{ item.name }}</div>
                            <div class="overlay">
                                <a style="background-color: #0d66c2" mat-icon-button class="mini-button jump-icon"
                                   (click)="jumpToSceneItem(item)"
                                   matTooltip="{{'general.jumpToScene' | transloco}}">
                                    <mat-icon style="color: white">link</mat-icon>
                                </a>
                            </div>
                        </div>
                    }
                    <span in-viewport class="flicking-arrow-prev">
                        <fa-icon size="2xl" [icon]="faArrowLeft"></fa-icon>
                    </span>
                    <span in-viewport class="flicking-arrow-next">
                        <fa-icon size="2xl" [icon]="faArrowRight"></fa-icon>
                    </span>
                </ngx-flicking>
            </div>
        }
    </div>
}


